<template>
    <ButtonCircle :disabled="!gridDisplay || disabled" @click="toggleSnapToGrid" :title="'Snap to the grid: ' + (!snapToGrid ? 'on' : 'off')">
        <i class="icon-target" :class="snapToGrid ? '' : 'icon-disabled'"></i>
    </ButtonCircle>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import ButtonCircle from "../../components/ButtonCircle";

    export default {
        name: "SnapToGrid",

        components: {
            ButtonCircle,
        },

        props: [
            'disabled',
        ],

        computed: {
            ...mapState('editor', [
                'snapToGrid',
                'gridDisplay',
            ]),

        },

        methods: {
            ...mapMutations('editor', [
                'setSnapToGrid',
            ]),

            toggleSnapToGrid() {
                this.setSnapToGrid(!this.snapToGrid);
            },

        },

    }
</script>

<style scoped>

</style>